import {Component, Inject, Input} from '@angular/core';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';

@Component({
  selector: 'app-cerf-confirmation-modal',
  templateUrl: './cerf-confirmation-dialog.component.html',
  styleUrls: ['./cerf-confirmation-dialog.component.scss']
})
export class CerfConfirmationDialogComponent {
  public currentCommentText = '';

  constructor(public dialogRef: MdDialogRef<CerfConfirmationDialogComponent>,
              @Inject(MD_DIALOG_DATA) public data: DialogData) { }


}

interface DialogData {
  message: string;
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/cerf/components/cerf-confirmation-dialog/cerf-confirmation-dialog.component.ts